const data = {
  id: 1,
  title: 'Look at the picture and fill in the blanks',
  subTitle: 'Nhìn hình ảnh và điền vào chỗ trống',
  audioUrl: '',
  imageUrl: 'https://cloud.softech.vn/storage/SachSo/Images/Vocabulary/Starters/school.png',
  question: 'This is my ___.',
  // answers: 'school',
  answers: [
    { id: 1, answer: 'school', isCorrect: true },
  ],
};

export default data;
